import moment from 'moment'

const HB_REGEX = /^# HB(\d+) - ([^ ]+) - offset (\d+) \+ (\d+) bytes(.*)$/

/**
 * Dado um arquivo que pode ser um .hblist.hex ou não,
 * tenta achar a primeira linha que descreve um heartbeat
 * e retorna o seu offset. Usado pelo "rd rejoin"
 * @param {string} str
 */
export function detectFirstOffset(str) {
  if (str == null || Array.isArray(str) || Buffer.isBuffer(str)) {
    return null
  }

  const firstHb = detectFirstHb(str)
  return firstHb && firstHb.startPointer
}

function detectFirstHb(str) {
  const lines = str.split('\n')
  for (let line of lines) {
    let m = line.match(HB_REGEX)
    if (m) {
      const result = {
        id: +m[1],
        receivedOn: moment(m[2]).toDate(),
        startPointer: parseInt(m[3]),
        endPointer: parseInt(m[3]) + parseInt(m[4]),
        rdLen: parseInt(m[4])
      }

      parseFlags(result, m[5])

      return result
    }
  }

  return null
}

function parseFlags(head, str) {
  if (str == null) return null
  if (str.trim().toLowerCase() == 'gap') return null
  if (str.trim().length > 0) head.flags = JSON.parse(str)
}
